export const demoAnnouncements = [
  {
    announcement_id: 1001,
    title: 'Welcome to Demo Workspace',
    message: 'This is a demo announcement.',
    created_by: 'System Admin',
    attachment_url: null,
    start_date: null,
    end_date: null,
    status: null,
    created_date: '2026-06-01T09:00:00.000Z',
  },
  {
    announcement_id: 1002,
    title: 'New Employee Onboarding',
    message: 'New onboarding materials are available.',
    created_by: 'HR Team',
    attachment_url: null,
    start_date: null,
    end_date: null,
    status: 'Active',
    created_date: '2026-05-30T14:15:00.000Z',
  },
  {
    announcement_id: 1003,
    title: 'Office Maintenance',
    message: 'Maintenance scheduled this weekend.',
    created_by: 'Facilities Team',
    attachment_url: null,
    start_date: null,
    end_date: null,
    status: 'Active',
    created_date: '2026-05-28T11:45:00.000Z',
  },
];

export const demoWfhRequests = [
  {
    request_type: 'WFH Request',
    id: 1001,
    employee_id: 'NUB033',
    user_id: 233,
    username: 'John Doe',
    department_name: 'Engineering',
    designations: 'Software Developer',
    start_date: '2026-06-10',
    end_date: '2026-06-11',
    days: 2,
    status: 'Pending',
    reason: 'Internet installation at home',
    applied_on: '2026-06-01T09:06:53.000Z',
    actioned_by: null,
  },
  {
    request_type: 'WFH Request',
    id: 1002,
    employee_id: 'NUB041',
    user_id: 241,
    username: 'Alex paul',
    department_name: 'QA',
    designations: 'QA Engineer',
    start_date: '2026-06-15',
    end_date: '2026-06-15',
    days: 1,
    status: 'Approved',
    reason: 'Medical Appointment',
    applied_on: '2026-05-29T11:20:00.000Z',
    actioned_by: 'Manager',
  },
  {
    request_type: 'WFH Request',
    id: 1003,
    employee_id: 'NUB052',
    user_id: 252,
    username: 'Eddy',
    department_name: 'HR',
    designations: 'HR Executive',
    start_date: '2026-06-20',
    end_date: '2026-06-22',
    days: 3,
    status: 'Rejected',
    reason: 'Personal Work',
    applied_on: '2026-05-28T15:45:00.000Z',
    actioned_by: 'HR Manager',
  },
];

export const demoProfileAuditLogs = [
  {
    id: 242,
    user_id: 268,
    action: 'INSERT',
    changed_fields: [
      'education_level',
      'degree_name',
      'field_of_study',
      'institute',
    ],
    old_data: {},
    new_data: {
      education_level: 'Bachelor',
      degree_name: 'B.E',
      field_of_study: 'Computer Science',
      institute: 'KLE Institute',
      university_name: 'VTU',
      grade: '8.7',
      status: 'Completed',
    },
    changed_by: 268,
    changed_at: '2026-06-01T05:32:44.000Z',
    org_id: 88,
    username: 'John snow',
    employee_id: 'NUB033',
    changed_by_name: 'John Snow',
  },
  {
    id: 243,
    user_id: 268,
    action: 'UPDATE',
    changed_fields: ['primary_contact_number', 'address'],
    old_data: {
      primary_contact_number: '9876543210',
      address: 'Belgaum',
    },
    new_data: {
      primary_contact_number: '9988776655',
      address: 'Bangalore',
    },
    changed_by: 268,
    changed_at: '2026-06-02T09:15:00.000Z',
    org_id: 88,
    username: 'Arya Stark',
    employee_id: 'NUB033',
    changed_by_name: 'Arya stark',
  },
  {
    id: 244,
    user_id: 268,
    action: 'INSERT',
    changed_fields: ['full_name', 'relationship_with_employee'],
    old_data: {},
    new_data: {
      full_name: 'John Doe',
      relationship_with_employee: 'Father',
      primary_contact_number: '9123456789',
    },
    changed_by: 268,
    changed_at: '2026-06-03T11:45:00.000Z',
    org_id: 88,
    username: 'Captain Amerika',
    employee_id: 'NUB033',
    changed_by_name: 'Tony Stark',
  },
];

export const demoCompanyAuditLogs = [
  {
    id: 2055,
    org_id: 88,
    action: 'INSERT',
    changed_at: '2026-05-26T05:59:38.000Z',
    changed_by: 263,
    changed_fields: ['department_name', 'department_head', 'subDepartments'],
    employee_id: 'NUB037',
    username: 'John snow',
    old_data: {},
    new_data: {
      department_name: 'Engineering',
      department_head: 'Jenny',
      subDepartments: [
        {
          subDepartment: 'Frontend',
          subDepartmentId: '',
        },
      ],
    },
  },
  {
    id: 2056,
    org_id: 88,
    action: 'UPDATE',
    changed_at: '2026-05-27T08:20:00.000Z',
    changed_by: 263,
    changed_fields: ['department_head'],
    employee_id: 'NUB037',
    username: 'Elsa Snow',
    old_data: {
      department_head: 'Old Manager',
    },
    new_data: {
      department_head: 'New Manager',
    },
  },
  {
    id: 2057,
    org_id: 88,
    action: 'DELETE',
    changed_at: '2026-05-28T12:10:00.000Z',
    changed_by: 263,
    changed_fields: ['subDepartments'],
    employee_id: 'NUB037',
    username: 'Anna jenner',
    old_data: {
      subDepartments: [
        {
          subDepartment: 'Testing',
        },
      ],
    },
    new_data: {},
  },
];

export const demoPayrollLogs = [
  {
    id: 606,
    module_name: 'Create Payout',
    created_by: '158',
    created_at: '2026-05-23 09:34:10',
    action: 'Created',
    username: 'Donna paul',
    logs: JSON.stringify([
      {
        id: 286,
        username: 'Testing User',
        email: 'testing@nubaxdatalabs.com',
      },
    ]),
  },
  {
    id: 607,
    module_name: 'Generate Payslip',
    created_by: '158',
    created_at: '2026-05-23 09:34:21',
    action: 'Created',
    username: 'Steve hardy',
    logs: JSON.stringify([
      {
        username: 'Testing User',
        email: 'testing@nubaxdatalabs.com',
        org_name: 'Nubax Data Labs',
        Address: 'Belgaum',
      },
    ]),
  },
  {
    id: 608,
    module_name: 'Payroll Approval',
    created_by: '158',
    created_at: '2026-05-24 10:15:00',
    action: 'Approved',
    username: 'Micky',
    logs: JSON.stringify([
      {
        payroll_month: 'May 2026',
        employees_processed: 45,
        total_amount: '₹12,50,000',
      },
    ]),
  },
];

export const demoWorkWeekRules = [
  {
    id: 120,
    work_week_rule_name: 'Standard 5 Day Week',
    description: 'Monday to Friday working schedule',
    user_count: 12,
  },
  {
    id: 121,
    work_week_rule_name: 'Hybrid Team Schedule',
    description: 'Monday to Thursday office, Friday remote',
    user_count: 8,
  },
  {
    id: 122,
    work_week_rule_name: 'Support Team Rotation',
    description: 'Rotational weekend coverage schedule',
    user_count: 5,
  },
];

export const demoWorkWeekUsers = [
  {
    user_id: 289,
    Name: 'Kendall J',
    Employee_id: 'NUB043',
    designations: 'Developer',
    department_name: 'Software Development',
    work_week_configId: 120,
    work_week_rule_name: 'Standard 5 Day Week',
  },
  {
    user_id: 290,
    Name: 'Sansa Stark',
    Employee_id: 'NUB033',
    designations: 'Software Engineer',
    department_name: 'Software Development',
    work_week_configId: 121,
    work_week_rule_name: 'Hybrid Team Schedule',
  },
  {
    user_id: 291,
    Name: 'Loren K',
    Employee_id: 'NUB051',
    designations: 'QA Engineer',
    department_name: 'Quality Assurance',
    work_week_configId: null,
    work_week_rule_name: null,
  },
  {
    user_id: 292,
    Name: 'Brad pitt',
    Employee_id: 'NUB055',
    designations: 'HR Executive',
    department_name: 'Human Resources',
    work_week_configId: 120,
    work_week_rule_name: 'Standard 5 Day Week',
  },
];

export const demoUserDirectory = [
  {
    user_id: 123,
    username: 'Walter White',
    Employee_id: 'NUB004',
    IsActive: 1,
    org_id: 88,
    Designation: 'Chief Executive Officer',
    Department: 'Management',
    image_url: null,
    role: 'admin',
  },
  {
    user_id: 901,
    username: 'Don Draper',
    Employee_id: 'NUB005',
    IsActive: 1,
    org_id: 88,
    Designation: 'HR Manager',
    Department: 'Human Resources',
    image_url: null,
    role: 'admin',
  },
  {
    user_id: 902,
    username: 'Dexter Morgen',
    Employee_id: 'NUB006',
    IsActive: 1,
    org_id: 88,
    Designation: 'Software Engineer',
    Department: 'Software Development',
    image_url: null,
    role: 'betauser',
  },
  {
    user_id: 903,
    username: 'James Bond',
    Employee_id: 'NUB033',
    IsActive: 1,
    org_id: 88,
    Designation: 'Full Stack Developer',
    Department: 'Software Development',
    image_url: null,
    role: 'employee',
  },
  {
    user_id: 904,
    username: 'Peter Parker',
    Employee_id: 'NUB041',
    IsActive: 1,
    org_id: 88,
    Designation: 'QA Engineer',
    Department: 'Quality Assurance',
    image_url: null,
    role: 'employee',
  },
];

export const demoProfileDetails = [
  {
    username: 'Walter White',
    employee_id: 'NUB004',
    department_name: 'Management',
    designations: 'Chief Executive Officer',
    subdepartment: 'Administration',
    dob: '1985-05-10',
    gender: 'Male',
    blood_group: 'O+',
    marital_status: 'Married',
    official_email_id: 'walter@nucleusteq.com',
    personal_email_id: 'walter@gmail.com',
    phone_number: '9876543210',
    alternate_phone_number: '9876543211',
    current_address: 'Bangalore',
    permanent_address: 'Mumbai',
    image_url: null,
  },
];

export const demoEmployeeWorkDetails = [
  {
    employee_id: 'NUB004',
    date_of_joining: '2024-01-15',
    probation_period: '6 Months',
    employee_type: 'Permanent',
    work_location: 'Bangalore',
    designations: 'Software Developer',
    department_name: 'IT',
    subdepartment: 'Development',
  },
];

export const demoAssignedManagers = [
  {
    user_id: 233,
    username: 'John McClane',
    reporting_manager1_user_id: 101,
    reporting_manager1_username: 'Gustavo Fring',
    reporting_manager1_department: 'Management',
    reporting_manager1_designation: 'Director',
    reporting_manager1_status: 'Active',
    reporting_manager2_user_id: 102,
    reporting_manager2_username: 'Mike Ehrmantraut',
    reporting_manager2_department: 'Operations',
    reporting_manager2_designation: 'Senior Manager',
    reporting_manager2_status: 'Active',
  },
];

export const demoManagers = [
  {
    id: 101,
    name: 'Gustavo Fring',
    department_name: 'Management',
    designation_name: 'Director',
    slot: 1,
  },
  {
    id: 102,
    name: 'Mike Ehrmantraut',
    department_name: 'Operations',
    designation_name: 'Senior Manager',
    slot: 2,
  },
];

export const demoDocumentsResponse = [
  {
    id: 21,
    fileUrl: 'https://example.com/aadhaar_card.pdf',
    filename: 'aadhaar_card.pdf',
    documentID: '09975432460',
    filetype: 'Aadhaar Card',
    verification: 'Verified',
    uploadedBy: 'Admin',
  },
  {
    id: 22,
    fileUrl: 'https://example.com/pan_card.pdf',
    filename: 'pan_card.pdf',
    documentID: 'DNHGTY546D',
    filetype: 'Pan Card',
    verification: 'Not Verified',
    uploadedBy: 'Admin',
  },
];

export const demoWorkWeekResponse = {
  status: 'success',
  data: [
    {
      work_week_rule_name: 'General Work Week',
      description: 'Saturday & Sunday Holiday',
      date: '2026-03-01T00:00:00.000Z',
      day: 'Sunday',
      is_working: 'holiday',
    },
    {
      work_week_rule_name: 'General Work Week',
      description: 'Saturday & Sunday Holiday',
      date: '2026-03-01T00:00:00.000Z',
      day: 'Monday',
      is_working: 'fullday',
    },
    {
      work_week_rule_name: 'General Work Week',
      description: 'Saturday & Sunday Holiday',
      date: '2026-03-01T00:00:00.000Z',
      day: 'Tuesday',
      is_working: 'fullday',
    },
    {
      work_week_rule_name: 'General Work Week',
      description: 'Saturday & Sunday Holiday',
      date: '2026-03-01T00:00:00.000Z',
      day: 'Wednesday',
      is_working: 'fullday',
    },
    {
      work_week_rule_name: 'General Work Week',
      description: 'Saturday & Sunday Holiday',
      date: '2026-03-01T00:00:00.000Z',
      day: 'Thursday',
      is_working: 'fullday',
    },
    {
      work_week_rule_name: 'General Work Week',
      description: 'Saturday & Sunday Holiday',
      date: '2026-03-01T00:00:00.000Z',
      day: 'Friday',
      is_working: 'fullday',
    },
    {
      work_week_rule_name: 'General Work Week',
      description: 'Saturday & Sunday Holiday',
      date: '2026-03-01T00:00:00.000Z',
      day: 'Saturday',
      is_working: 'fullday',
    },
  ],
};

export const demoEmergancyContact = [
  {
    pri_contact_id: 125,
    user_id: 233,
    full_name: 'John Cena',
    relationship_with_employee: 'Friend',
    primary_contact_number: '9876543210',
    address: 'nbhgtyuj',
    alternate_contact_number: '',
    email_address: 'John@ggfdr.com',
    priority_level: 'Primary',
    remarks: '',
  },
];

export const demoEducationDetails = [
  {
    education_id: 97,
    user_id: 263,
    education_level: 'Bachelor',
    degree_name: 'BTech',
    field_of_study: 'computer science',
    institute: 'Boxton',
    university_name: 'Global',
    start_date: '2021',
    end_date: '2025',
    grade: '9.87',
    country: 'German',
    docname: null,
    mode_of_study: 'Full Time',
    status: 'Completed',
    remarks: null,
  },
];

export const demodailyLogsdata = [
  {
    employee_id: 138,
    username: 'Shown Mendes',
    formattedClockIn: '10:15',
    formattedClockOut: '7:00',
    clock_In: '10:15',
    clock_out: '7:00',
    formattedDate: '2026-06-03',
    clock_in_latitude: '15.82900620',
    clock_in_longitude: '74.50555230',
    clock_out_latitude: '15.82858670',
    clock_out_longitude: '74.50512580',
  },
];

export const demoHistoricalLogs = [
  {
    employee_id: 138,
    username: 'Shawn Mendes',
    formattedClockIn: '10:15',
    formattedClockOut: '--',
    firstclockin: '10:15',
    formattedDate: '2026-06-03',
    formatted_date: '2026-05-15',
    status: 'Present',
    totalhours: '8h 40m',
    approval_status: 'pending',
    clock_in_latitude: '15.82900620',
    clock_in_longitude: '74.50555230',
    clock_out_latitude: '15.82858670',
    clock_out_longitude: '74.50512580',
  },
  {
    employee_id: 120,
    username: 'Kyros',
    formattedClockIn: '--',
    formattedClockOut: '--',
    firstclockin: '',
    lastclockout: '',
    formattedDate: '2026-06-03',
    formatted_date: '2026-06-10',
    status: 'Absent',
    totalhours: '0h',
    approval_status: 'rejected',
    clock_in_latitude: '15.82900620',
    clock_in_longitude: '74.50555230',
    clock_out_latitude: '15.82858670',
    clock_out_longitude: '74.50512580',
  },
  {
    employee_id: 121,
    username: 'John Doe',
    formattedClockIn: '09:00',
    formattedClockOut: '18:00',
    firstclockin: '09.00',
    lastclockout: '18.00',
    formattedDate: '2026-06-03',
    formatted_date: '2026-06-11',
    status: 'Present',
    totalhours: '9h',
    approval_status: 'approved',
    clock_in_latitude: '15.82900620',
    clock_in_longitude: '74.50555230',
    clock_out_latitude: '15.82858670',
    clock_out_longitude: '74.50512580',
  },
];

export const demoEmployeehistLogs = [
  {
    formatted_date: '2026-15-30',
    employee_id: 140,
    name: 'Peter Parker',
    formattedClockIn: '10:15',
    formattedClockOut: '7:00',
    status: 'Present',
    totalhours: '8h 40m',
    firstclockin: '10.15',
    lastclockout: '7.00',
    clock_in_latitude: '15.82900620',
    clock_in_longitude: '74.50555230',
    clock_out_latitude: '15.82858670',
    clock_out_longitude: '74.50512580',
  },
  {
    formatted_date: '2026-15-30',
    employee_id: 142,
    name: 'Gwen Stacy',
    formattedClockIn: '9:50',
    formattedClockOut: '6:20',
    firstclockin: '9.50',
    lastclockout: '6.20',
    status: 'Present',
    totalhours: '8h 30m',
    clock_in_latitude: '15.82900620',
    clock_in_longitude: '74.50555230',
    clock_out_latitude: '15.82858670',
    clock_out_longitude: '74.50512580',
  },
  {
    formatted_date: '2026-15-30',
    employee_id: 140,
    name: 'Miles Morals',
    formattedClockIn: '',
    formattedClockOut: '',
    firstclockin: '',
    lastclockout: '',
    status: 'Absent',
    totalhours: '',
    clock_in_latitude: '15.82900620',
    clock_in_longitude: '74.50555230',
    clock_out_latitude: '15.82858670',
    clock_out_longitude: '74.50512580',
  },
];

export const demoAttendanceRequest = [
  {
    id: 1,
    formatted_date: '2026-06-01',
    username: 'Shawn Mendes',
    formattedClockIn: '09:30',
    formattedClockOut: '--',
    reason: 'Forgot to clock out',
    status: 'PENDING',
  },
  {
    id: 2,
    formatted_date: '2026-06-02',
    username: 'Kyros',
    formattedClockIn: '--',
    formattedClockOut: '--',
    reason: 'System issue',
    status: 'APPROVED',
  },
  {
    id: 3,
    formatted_date: '2026-06-03',
    username: 'John Doe',
    formattedClockIn: '10:00',
    formattedClockOut: '18:00',
    reason: 'Manual correction',
    status: 'REJECTED',
  },
];

export const demoUpcomingFestivals = [
  {
    org_id: 67,
    holiday_description: 'Happy Ganesh Chaturthi',
    date: '2026-08-17',
    image_url: 'https://placehold.co/1200x600/png?text=Happy+Ganesh+Chaturthi',
  },
  {
    org_id: 67,
    holiday_description: 'Happy Raksha Bandhan Day!',
    date: '2026-08-28',
    image_url: 'https://placehold.co/1200x600/png?text=Happy+Raksha+Bandhan',
  },
  {
    org_id: 67,
    holiday_description: 'Happy Diwali',
    date: '2026-09-14',
    image_url: 'https://placehold.co/1200x600/png?text=Happy+Diwali',
  },
];

export const demoTodaysonLeaveEmployee = [
  {
    id: 1,
    name: 'Steve Harrignton',
  },
  {
    id: 2,
    name: 'John Doe',
  },
];

export const DemoWFHEmployees = [
  {
    id: 5,
    username: 'Karlos',
  },
];

export const demoTodayBirthday = [
  {
    id: 10,
    username: 'Sammy Morals',
  },
];

export const demoWorkAnniversary = [
  {
    id: 10,
    username: 'Rohit Sharma',
  },
];

export const demoNewJoinee = [
  {
    id: 10,
    username: 'Virat Kohli',
  },
];

export const demoLeaveDetails = [
  {
    rule_id: 71,
    leave_type: 'Earn Leave',
    details: [
      {
        label: 'Credited Leaves',
        value: 14,
      },
      {
        label: 'Total Leaves',
        value: 12,
      },
      {
        label: 'Applied Leaves',
        value: 6,
      },
      {
        label: 'Penalty Deduction',
        value: 1,
      },
      {
        label: 'Carry Forwards',
        value: 4,
      },
    ],
    balance: 11,
  },
  {
    rule_id: 72,
    leave_type: 'Comp Off',
    details: [
      {
        label: 'Credited Leaves',
        value: 0,
      },
      {
        label: 'Total Leaves',
        value: 0,
      },
      {
        label: 'Applied Leaves',
        value: 0,
      },
      {
        label: 'Penalty Deduction',
        value: 0,
      },
      {
        label: 'Carry Forwards',
        value: 0,
      },
    ],
    balance: 0,
  },
  {
    rule_id: 74,
    leave_type: 'Loss of pay',
    details: [
      {
        label: 'Credited Leaves',
        value: 365,
      },
      {
        label: 'Total Leaves',
        value: 365,
      },
      {
        label: 'Applied Leaves',
        value: 0,
      },
      {
        label: 'Penalty Deduction',
        value: 0,
      },
      {
        label: 'Carry Forwards',
        value: 0,
      },
    ],
    balance: 365,
  },
];

export const demoAcccuralHistory = [
  {
    id: 2328,
    rule_id: 71,
    user_id: 138,
    date: '2026-01-01T00:00:00.000Z',
    credited_leaves: 9,
    applied_leaves: 0,
    penalty_leaves: 0,
    carry_forward_leaves: 4,
    closing_balance: 13,
    last_updated: '2026-01-13T05:35:35.000Z',
    month: 'Jan',
    year: 2026,
  },
  {
    id: 3195,
    rule_id: 71,
    user_id: 138,
    date: '2026-02-01T00:00:00.000Z',
    credited_leaves: 1,
    applied_leaves: 4,
    penalty_leaves: 0,
    carry_forward_leaves: 13,
    closing_balance: 10,
    last_updated: '2026-02-18T01:10:00.000Z',
    month: 'Feb',
    year: 2026,
  },
  {
    id: 3712,
    rule_id: 71,
    user_id: 138,
    date: '2026-03-01T00:00:00.000Z',
    credited_leaves: 1,
    applied_leaves: 0,
    penalty_leaves: 0,
    carry_forward_leaves: 10,
    closing_balance: 11,
    last_updated: '2026-03-01T07:06:00.000Z',
    month: 'Mar',
    year: 2026,
  },
  {
    id: 4221,
    rule_id: 71,
    user_id: 138,
    date: '2026-04-01T00:00:00.000Z',
    credited_leaves: 1,
    applied_leaves: 0,
    penalty_leaves: 1,
    carry_forward_leaves: 11,
    closing_balance: 11,
    last_updated: '2026-04-05T01:10:00.000Z',
    month: 'Apr',
    year: 2026,
  },
  {
    id: 4731,
    rule_id: 71,
    user_id: 138,
    date: '2026-05-01T00:00:00.000Z',
    credited_leaves: 1,
    applied_leaves: 1,
    penalty_leaves: 0,
    carry_forward_leaves: 11,
    closing_balance: 11,
    last_updated: '2026-05-08T01:10:00.000Z',
    month: 'May',
    year: 2026,
  },
  {
    id: 5249,
    rule_id: 71,
    user_id: 138,
    date: '2026-06-01T00:00:00.000Z',
    credited_leaves: 1,
    applied_leaves: 0,
    penalty_leaves: 0,
    carry_forward_leaves: 11,
    closing_balance: 12,
    last_updated: '2026-06-01T01:00:00.000Z',
    month: 'Jun',
    year: 2026,
  },
];

export const demoAssignedLeaves = [
  {
    rule_id: 71,
    leave_type: 'Earn Leave',
  },
  {
    rule_id: 72,
    leave_type: 'Comp Off',
  },
];

export const demoLeaveLogs = [
  {
    employee_id: 'NUB004',
    username: 'John snow',
    rule_id: 71,
    leave_type: 'Earn Leave',
    start_date: '2025-08-13T00:00:00.000Z',
    end_date: '2025-08-14T00:00:00.000Z',
    applied_on: '2025-08-26T00:00:00.000Z',
    status: 'Approved',
    action: null,
    days: 2,
  },
  {
    employee_id: 'NUB003',
    username: 'Michal Jackson',
    rule_id: 71,
    leave_type: 'Earn Leave',
    start_date: '2025-11-21T00:00:00.000Z',
    end_date: '2025-11-22T00:00:00.000Z',
    applied_on: '2025-11-24T00:00:00.000Z',
    status: 'Rejected',
    action: null,
    days: 2,
  },
  {
    employee_id: 'NUB002',
    username: 'Kim lee',
    rule_id: 71,
    leave_type: 'Earn Leave',
    start_date: '2025-11-28T00:00:00.000Z',
    end_date: '2025-11-29T00:00:00.000Z',
    applied_on: '2025-12-02T00:00:00.000Z',
    status: 'Deleted',
    action: null,
    days: 2,
  },
  {
    employee_id: 'NUB001',
    username: 'Peter Parker',
    rule_id: 71,
    leave_type: 'Earn Leave',
    start_date: '2026-05-15T00:00:00.000Z',
    end_date: '2026-05-15T00:00:00.000Z',
    applied_on: '2026-06-01T00:00:00.000Z',
    status: 'Pending',
    action: null,
    days: 1,
  },
];

export const demoLeaveRecords = [
  {
    user_id: 263,
    employee_id: 'NUB037',
    employee_name: 'Ana D Armas',
    totalleaves: 9,
    appliedleaves: 5,
    appliedleavebalance: 4,
    totalcompoff: 1,
    earncompoffapplied: 0,
    compoffleavebalance: 1,
    lossofpay: 4,
    totalloassofpay: 4,
    lopleavebalance: 4,
  },
  {
    user_id: 263,
    employee_id: 'NUB037',
    employee_name: 'Barbara Pelvin',
    totalleaves: 4,
    appliedleaves: 3,
    appliedleavebalance: 1,
    totalcompoff: 6,
    earncompoffapplied: 3,
    compoffleavebalance: 3,
    lossofpay: 2,
    totalloassofpay: 0,
    lopleavebalance: 2,
  },
];

export const demoassigneLeaveRule = [
  {
    user_id: 155,
    employee_id: 'NUB002',
    full_name: 'Shown Mendes',
    Designation: 'Software Developer',
    Department: 'IT',
    assigned_id: '81,88',
    rules: [
      {
        rule_id: 1,
        rule_name: 'comp Off',
      },
    ],
  },
  {
    user_id: 156,
    employee_id: 'NBX020',
    full_name: 'Justine bieber',
    Designation: 'Hr',
    Department: 'Management',
    assigned_id: '90,87,88,81',
    rules: [
      {
        rule_id: 2,
        rule_name: 'Earn Leave',
      },
      {
        rule_id: 3,
        rule_name: 'Loss of Pay',
      },
    ],
  },
];

export const demoManagersList = [
  {
    reporting_manager_record_id: 77,
    manager_user_id: 233,
    manager_name: 'Taylor Swift',
    email: 'arya.bhatkande@nubaxdatalabs.com',
    employee_id: 'NUB033',
    designation_Id: 243,
    department_Id: 484,
    department_name: 'Software development',
    designation_name: 'Developer',
  },
];

export const demoUsersReportingList = [
  {
    user_id: 233,
    username: 'John Jacobs',
    department_id: 484,
    department_name: 'Software development',
    designation_name: 'Developer',
    reporting_manager1_name: null,
    reporting_manager1_record_id: null,
    reporting_manager2_name: null,
    reporting_manager2_record_id: null,
    role: 'admin',
  },
  {
    user_id: 159,
    username: 'Kareena sharma',
    department_id: 479,
    department_name: 'Human Resources',
    designation_name: 'HR Executive',
    reporting_manager1_name: 'Arya Bhatkande',
    reporting_manager1_record_id: 77,
    reporting_manager2_name: null,
    reporting_manager2_record_id: null,
    role: 'betauser',
  },
  {
    user_id: 160,
    username: 'Anna rose',
    department_id: 484,
    department_name: 'Software development',
    designation_name: 'Frontend Developer',
    reporting_manager1_name: 'Arya Bhatkande',
    reporting_manager1_record_id: 77,
    reporting_manager2_name: null,
    reporting_manager2_record_id: null,
    role: 'employee',
  },
];

export const demoDepartments = [
  {
    org_id: 88,
    department_id: 483,
    department_name: 'Quality assurance',
    department_head_id: '158',
    department_head_name: 'Dua Lipa',
    subdepartments: [
      {
        count: 2,
        subdepartment: 'Testing',
        subdepartment_id: 607,
      },
    ],
  },
  {
    org_id: 88,
    department_id: 484,
    department_name: 'Software development',
    department_head_id: '263',
    department_head_name: 'Camila D',
    subdepartments: [
      {
        count: 3,
        subdepartment: 'Dev',
        subdepartment_id: 608,
      },
    ],
  },
];

export const demoDesignations = [
  {
    designations: 'Developer',
    designation_count: 3,
    org_id: 88,
    id: 243,
  },
  {
    designations: 'Tester',
    designation_count: 2,
    org_id: 88,
    id: 242,
  },
];

export const demoCompanyReportingManager = [
  {
    id: 1,
    name: 'Hailey',
    role: 'user',
    department: 'Software',
    designation: 'Developer',
    reportingAuthorities: [
      {
        id: 101,
        name: 'Taylor Swift',
        slot: 1,
      },
    ],
  },
  {
    id: 2,
    name: 'Selena Gomez',
    role: 'user',
    department: 'Quality Assurance',
    designation: 'Tester',
    reportingAuthorities: [
      {
        id: 102,
        name: 'Adele',
        slot: 1,
      },
      {
        id: 103,
        name: 'Ed Sheeran',
        slot: 2,
      },
    ],
  },
  {
    id: 3,
    name: 'Justin Bieber',
    role: 'admin',
    department: 'Software',
    designation: 'Team Lead',
    reportingAuthorities: [],
  },
];

export const demoPayrollStructure = [
  {
    assigned_id: 116,
    user_id: 263,
    payroll_structure_id: 48,
    payroll_name: 'Nubax',
    payroll_description: 'nubax',
    employee_name: 'Alex k',
    employee_id: 'NUB037',
    designation: 'Developer',
    ctc: 50000,
    ctc_per_month: 4167,
    basic: 25000,
    basic_formula: 0.5,
    basic_month: 2084,
    hra: 10000,
    hra_formula: 0.2,
    hra_month: 833,
    conveyance_allowance: 15000,
    conveyance_allowance_month: 1250,
    special_allowance: 0,
    special_allowance_month: 0,
    overtime: 0,
  },
  {
    assigned_id: 116,
    user_id: 263,
    payroll_structure_id: 48,
    payroll_name: 'Nubax',
    payroll_description: 'nubax',
    employee_name: 'Sierra M',
    employee_id: 'NUB040',
    designation: 'Developer',
    ctc: 80000,
    ctc_per_month: 4200,
    basic: 30000,
    basic_formula: 0.5,
    basic_month: 2084,
    hra: 15000,
    hra_formula: 0.2,
    hra_month: 833,
    conveyance_allowance: 20000,
    conveyance_allowance_month: 1400,
    special_allowance: 500,
    special_allowance_month: 500,
    overtime: 0,
  },
];

export const demoCraeteStructure = [
  {
    id: 48,
    name: 'Nubax',
    description: 'Cost to Company',
    basic_formula: 0.5,
    hra_formula: 0.2,
    conveyance_allowance_formula: 'None',
    special_allowance_formula: 'Balancing Amount of CTC',
    overtime: 0,
    no_of_employees: 2,
  },
];

export const demoRunPayrollData = [
  {
    name: 'Natasha',
    user_id: 263,
    employee_id: 'NUB035',
    designation: 'Developer',
    ctc: 50000,
    ctc_per_month: 4166.67,
    basic_formula: 0.5,
    basic_month: 2083.34,
    hra_formula: 0.2,
    hra_month: 833.33,
    conveyance_allowance: 15000,
    conveyance_allowance_month: 1250,
    special_allowance_month: 0,
    day_salary: 138.89,
    net_pay: 4166.67,
    lop: 0,
    adoc_sum: 0,
    adoc_variable_amount: 0,
    variable_sum: 0,
    leave_rule_id: null,
    amount: null,
    type: null,
  },
  {
    name: 'Gwen stacy',
    user_id: 263,
    employee_id: 'NUB038',
    designation: 'Developer',
    ctc: 70000,
    ctc_per_month: 4200.67,
    basic_formula: 0.5,
    basic_month: 2150,
    hra_formula: 0.4,
    hra_month: 900.1,
    conveyance_allowance: 18000,
    conveyance_allowance_month: 1300,
    special_allowance_month: 700,
    day_salary: 250.15,
    net_pay: 4210,
    lop: 0,
    adoc_sum: 0,
    adoc_variable_amount: 0,
    variable_sum: 0,
    leave_rule_id: null,
    amount: null,
    type: null,
  },
];

export const demoHoldSalaryUsersResponse = {
  status: 'success',
  message: 'Data fetched',
  data: {
    on_hold_salary_users: [
      {
        employee_id: 291,
        name: 'Demo Employee 1',
      },
      {
        employee_id: 292,
        name: 'Demo Employee 2',
      },
    ],
  },
};

export const demoSalaryStructureResponse = {
  status: 'success',
  data: {
    ctc: 50000,
    effective_from: '2026-01-01T00:00:00.000Z',
    basic: 25000,
    hra: 10000,
    special_allowance: 0,
    conveyance_allowance: 15000,
    ctc_per_month: 4166.67,
    basic_month: 2083.34,
    hra_month: 833.33,
    conveyance_allowance_month: 1250,
    special_allowance_month: 0,
    overtime: 0,
  },
};

export const demoAdocAndVariableResponse = [
  {
    id: 66,
    user_id: 158,
    amount: 20000,
    type: 'variable',
    description: 'Performance Variable Pay',
    name: 'John Cena',
    employee_id: 'NUB005',
  },
  {
    id: 67,
    user_id: 156,
    amount: 5000,
    type: 'adoc',
    description: 'Special Incentive',
    name: 'sammy mac',
    employee_id: 'NBX020',
  },
  {
    id: 68,
    user_id: 263,
    amount: 10000,
    type: 'variable',
    description: 'Quarterly Bonus',
    name: 'Bruno Mars',
    employee_id: 'NUB037',
  },
];

export const demoPayoutData = [
  {
    id: 363,
    name: 'Karlos J',
    employee_id: 'NUB013',
    designation: 'jr developer',
    month: 'September',
    year: 2025,
    status: 'PENDING',
    is_payslip: 1,
    adoc_variable_amount: 1000,
    hra_month: 500,
    basic_month: 300,
    ctc_per_month: 4500,
    lop: 1500,
    net_pay: 3000,
  },
  {
    id: 363,
    name: 'Garp D',
    employee_id: 'NUB015',
    designation: 'jr developer',
    month: 'September',
    year: 2025,
    status: 'PENDING',
    is_payslip: 1,
    adoc_variable_amount: 800,
    hra_month: 200,
    basic_month: 400,
    ctc_per_month: 5000,
    net_pay: 5700,
    lop: '0.00',
  },
  {
    id: 363,
    name: 'Shanks',
    employee_id: 'NUB018',
    designation: 'jr developer',
    month: 'September',
    year: 2025,
    status: 'PENDING',
    lop: '0.00',
    is_payslip: 1,
    adoc_variable_amount: 300,
    hra_month: 100,
    basic_month: 450,
    ctc_per_month: 4000,
    net_pay: 5000,
  },
];

export const demoPayslipUsers = [
  {
    name: 'Shawn Mendes',
    user_id: 186,
    designation_name: 'jr developer',
    department_name: 'Development',
  },
  {
    name: 'Selena',
    user_id: 198,
    designation_name: 'Intern',
    department_name: 'Management',
  },
  {
    name: 'Taylor swift',
    user_id: 201,
    designation_name: 'manager',
    department_name: 'Management',
  },
  {
    name: 'Sabrina',
    user_id: 158,
    designation_name: 'front end developer',
    department_name: 'Software development',
  },
];

export const demoPayrollOverview = {
  status: 'success',
  message: 'Data received.',
  data: [
    {
      total_employees: 4,
      payroll_completed: 9,
      gross_pay: 800,
      net_pay: 500,
      payslip: 4,
    },
  ],
};

export const demoFinalSettlementData = {
  status: 'success',
  message: 'Data received.',
  data: [
    {
      user_id: 263,
      Full_Name: 'Steve H',
      Employee_ID: 'NUB037',
      Designation_Name: 'Developer',
      Department_Name: 'Development',
      SubDepartment_Name: 'Frontend',
      Resignation_Date: '2026-05-15',
      Last_Working_Day: '2026-05-31',
      Month_CTC: 4166.67,
      Remaining_Leave: 5,
      EL_Encashment: 2000,
      LOP_Deduction_amount: 500,
      Final_Amount: 5666.67,
      Monthly_Salary: 4166.67,
      Conveyance_Allowance: 1250,
      LOP_Leaves: 1,
      Comp_Off_Balance: 2,
      settlement_status: 'Paid',
      status: 'Pending',
    },
    {
      user_id: 233,
      Full_Name: 'Tom Holland',
      Employee_ID: 'NUB036',
      Designation_Name: 'Developer',
      Department_Name: 'Development',
      SubDepartment_Name: 'Backend',
      Resignation_Date: '2026-05-10',
      Last_Working_Day: '2026-05-25',
      Month_CTC: 5000,
      Remaining_Leave: 3,
      EL_Encashment: 1000,
      LOP_Deduction_amount: 200,
      Final_Amount: 5800,
      Monthly_Salary: 5000,
      Conveyance_Allowance: 1000,
      LOP_Leaves: 0,
      Comp_Off_Balance: 1,
      settlement_status: 'Pending',
      status: 'Pending',
    },
  ],
};

export const demoResignedUser = [
  {
    Name: 'testing user',
    Employee_id: 'NUB045',
    DateofJoining: '2026-01-01',
    org_name: 'Nubax Data Labs',
    Address: 'Belgaum',
    logo_url: null,
    department_name: 'Quality assurance',
    designations: 'Developer',
    personalemail_id: 'abc@gmail.com',
    mobile_number: '8971669879',
    emergency_contact_number: '8971665499',
    address: 'bel bel',
    id: 79,
    user_id: 291,
    resignation_timestamp: '2026-06-09',
    status: 'approved',
    updated_at: '2026-06-09',
    updated_by: 'Dakota Jackson',
    Last_working_day: '2026-06-30',
    reason_for_rejection: null,
  },
  {
    Name: 'Harry Potter',
    Employee_id: 'NUB037',
    DateofJoining: null,
    org_name: 'Data Solutions',
    Address: 'Chennai',
    logo_url: null,
    department_name: 'Software development',
    designations: 'Developer',
    personalemail_id: 'harry.potter@gmail.com',
    mobile_number: '8007584727',
    emergency_contact_number: '8007584727',
    address: 'Chennai',
    id: 78,
    user_id: 263,
    resignation_timestamp: '2026-05-25',
    status: 'approved',
    updated_at: '2026-05-25',
    updated_by: 'John',
    Last_working_day: '2026-05-28',
    reason_for_rejection: null,
  },
  {
    Name: 'Hermione',
    Employee_id: 'NBX020',
    DateofJoining: null,
    org_name: 'Data Bricks',
    Address: 'Mumbai',
    logo_url: null,
    department_name: 'Quality assurance',
    designations: 'Tester',
    personalemail_id: 'Hermione@nubaxdatalabs.com',
    mobile_number: '8431142797',
    emergency_contact_number: '8431142797',
    address: 'Mumbai',
    id: 1,
    user_id: 156,
    resignation_timestamp: '2025-04-07',
    status: 'approved',
    updated_at: null,
    updated_by: 'John',
    Last_working_day: '2026-04-07',
    reason_for_rejection: 'test',
  },
];

export const demoRoles = [
  {
    role_id: 9,
    org_id: 88,
    role_name: 'Software Developer',
    description: 'software',
  },
   {
    role_id: 8,
    org_id: 88,
    role_name: 'Data Science',
    description: 'Data',
  },
   {
    role_id: 7,
    org_id: 88,
    role_name: 'Hr Management',
    description: 'management',
  },
];
